import React from 'react';
import { Chip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  outlined: {
    borderColor: '#323643',
    opacity: 0.6,
    height: 30,
    marginRight: 10,
    marginBottom: 5,
  },

  label: {
    color: '#323643',
  },
});

const CustomOutlinedChip = ({ label }) => {
  const classes = useStyles();

  return (
    <Chip
      classes={{ outlined: classes.outlined, label: classes.label }}
      variant="outlined"
      label={label}
    />
  );
};
export default CustomOutlinedChip;
